export default function sortByDate(a, b) {
  return new Date(a.date).getTime() - new Date(b.date).getTime();
}

export const createDeepDateSortOn = (dateKey = 'date') => (a, b) =>
  new Date(a[dateKey]).getTime() - new Date(b[dateKey]).getTime();
